import { Box, Skeleton } from '@mui/material';

export const FsDialogFooter = ({ loading = false, className = '', children }) => {
	return (
		<Box className={`fs-dialog-footer ${className}`}>
			{!loading ? (
				children
			) : (
				<Box className="flex flex-auto justify-center items-center">
					<Skeleton variant="text" sx={{ fontSize: '2rem', width: '150px' }} />
					<Skeleton className="!ml-3" variant="text" sx={{ fontSize: '2rem', width: '150px' }} />
				</Box>
			)}
		</Box>
	);
};
